import { ReduxAction, setAsyncData, failure, pending, success } from '../core';
import { SchedulingState, DailyShiftSchedule, NotAllowedMatch } from './types';
import { SchedulingAction } from './actions';

const initialState: SchedulingState = {
  dailyShiftSchedule: { isFetching: false },
  pairingRules: { isFetching: false },
};

export function schedulingReducer(state: SchedulingState = initialState, action: ReduxAction<any>): SchedulingState {
  switch (action.type) {
    case SchedulingAction.SET_IS_FETCHING:
      return {
        ...state,
        dailyShiftSchedule: setAsyncData(state.dailyShiftSchedule, (v) => (v.isFetching = action.data as boolean)),
      };
    case SchedulingAction.SET_SHIFTS:
      return {
        ...state,
        dailyShiftSchedule: setAsyncData(state.dailyShiftSchedule, (v) => (v.data = action.data as DailyShiftSchedule)),
      };
    case pending(SchedulingAction.FETCH_PAIRING_RULES):
      return {
        ...state,
        pairingRules: setAsyncData(state.pairingRules, (v) => (v.isFetching = true)),
      };
    case failure(SchedulingAction.FETCH_PAIRING_RULES):
    case success(SchedulingAction.FETCH_PAIRING_RULES):
    case SchedulingAction.SET_PAIRING_RULES:
      return {
        ...state,
        pairingRules: setAsyncData(state.pairingRules, (v) => {
          v.data = action.data as NotAllowedMatch[];
          v.isFetching = false;
        }),
      };
    default:
      return state;
  }
}
